/** Hilfen für Verlängern im Admin-Lizenz-UI (gleicher Lizenz-Key, noch nicht abgelaufen). */

export function isLicenseExpired(license) {
  const type = String(license?.license_type ?? '').toUpperCase();
  if (!license?.expires_at || type === 'PERMANENT') return false;
  const d = new Date(license.expires_at);
  if (isNaN(d.getTime())) return false;
  return d.getTime() < Date.now();
}

export function canRenewLicense(license) {
  const type = String(license?.license_type ?? '').toUpperCase();
  if (!license || type === 'PERMANENT') return false;
  if (!license.expires_at) return false;
  if (!license.is_active) return false;
  if (isLicenseExpired(license)) return false;
  return true;
}

export function calculateDefaultDurationDays(license) {
  const created = license?.created_at ? new Date(license.created_at) : null;
  const expires = license?.expires_at ? new Date(license.expires_at) : null;
  if (!created || !expires || isNaN(created.getTime()) || isNaN(expires.getTime())) {
    return 30;
  }
  const diffMs = expires.getTime() - created.getTime();
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));
  if (!Number.isFinite(diffDays) || diffDays <= 0) {
    return 30;
  }
  return diffDays;
}

export function toDateTimeLocalValue(value) {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return '';
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}
